import type {
  QuickbooksIntegrationResponse,
  QuickbooksStatusResponse,
} from '@contracts/quickbooks/QuickbooksIntegrationContract';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';

export const QuickbooksSettingsClient = {
  getRedirectUri: async (): Promise<QuickbooksIntegrationResponse> => {
    const response =
      await AuthenticatedClient.get<QuickbooksIntegrationResponse>(
        '/quickbooks/redirect',
      );
    return response.data;
  },

  getStatus: async (): Promise<QuickbooksStatusResponse> => {
    const response =
      await AuthenticatedClient.get<QuickbooksStatusResponse>(
        '/quickbooks/status',
      );
    return response.data;
  },

  disconnect: async (): Promise<QuickbooksStatusResponse> => {
    return await AuthenticatedClient.post('/quickbooks/disconnect');
  },
};
